import React from 'react';
import { SectionContainer } from 'components/Containers/SectionContainer/SectionContainer';
import { Row } from 'components/Containers/Row/Row';
import { Image } from 'components/Image/Image';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import './OfferErrorView.scss';
import Label from 'components/form/Label/Label';

export const OfferErrorView = ({ history, ...props }) => {
  return (
    <SectionContainer>
      <Row>
        <FlexContainer className="justify-between m-flex-column offerErrorView">
          <FlexContainer className="flex-column">
            <Label typeHeader={'h3'} className="H3 margB16">
              🤔 There should be offers here...
            </Label>
            <Label
              typeHeader={'h4'}
              className="h4 margB8 mobile-Body-1 margT32 m-margT24"
            >
              Sorry! we are fixing this right now. Check back again soon.
            </Label>
            <div className="margT32 m-margT24">
              <Image imgClass={'offerError'} />
            </div>
          </FlexContainer>
        </FlexContainer>
      </Row>
    </SectionContainer>
  );
};
